/**
 * Signposting Events
 *
 * Custom event bridge for the signposting location flow only
 * (nearby places / GPS). Credential / computer-use auth lives in
 * @/lib/computer-use/credential-events.
 */

// --------------

export const SIGNPOSTING_LOCATION_EVENT = 'signposting:location-received'

// --------------

export interface SignpostingLocationEventDetail {
  latitude: number
  longitude: number
  chatId: string
  savePreference: boolean
}

// --------------

export function emitLocationReceived(detail: SignpostingLocationEventDetail) {
  window.dispatchEvent(
    new CustomEvent(SIGNPOSTING_LOCATION_EVENT, { detail })
  )
}
